module.exports = __webpack_public_path__ + "static/250429_12M_2024_Announcement_Financial_Results-a35adbbf3d299fb0e470d26fddf6054c.pdf";